import { useState } from "react";
import { useGetAssignmentsQuery } from "../../assignments/assignmentsSlice";

const useTasksLink = () => {
  const { data: assignments, isLoading: assignmentsLoading } =
    useGetAssignmentsQuery();
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownClick = () => {
    setIsOpen((state) => !state);
  };

  const counter = Array.isArray(assignments) ? assignments?.length : 0;

  return {
    isOpen,
    handleDropdownClick,
    assignments,
    assignmentsLoading,
    counter,
  };
};

export default useTasksLink;
